<template>
    <div>
        <FormHeader/>
        <ShowStep :current="2"/>
        <SectionLabel>お客様情報</SectionLabel>
        <section class="content">
            <FormConfirm label="名前" :value="`${request.name1} ${request.name2}`"/>
            <FormConfirm label="カナ" :value="`${request.kana1} ${request.kana2}`"/>
            <FormConfirm label="郵便番号" :value="request.postcode"/>
            <FormConfirm label="都道府県" :value="request.pref"/>
            <FormConfirm label="市区町村" :value="request.city"/>
            <FormConfirm label="それ以降の住所" :value="request.address"/>
            <FormConfirm label="マンション・建物名" :value="request.bill"/>
            <FormConfirm label="電話番号" :value="request.tel"/>
            <FormConfirm label="メールアドレス" :value="request.email"/>
            <FormConfirm label="お支払い方法" :value="request.payment_type === 'credit' ? 'クレジットカード' : 'コンビニ後払い'"/>
        </section>
        <SectionLabel>申し込み詳細</SectionLabel>
        <section class="content">
            <ApplyDetailTable :price="price" :is-selected="true"/>
        </section>
        <SectionLabel>申し込み詳細</SectionLabel>
        <section class="content">
            規約を読んで同意しました
        </section>
        <section class="content">
            <div class="mt-8 flex flex-row justify-center px-4">
                <div class="flex-1 lg:flex-none mr-2">
                    <button type="button" class="cancel-button" @click="$emit('cancel')" :disabled="isProcessing">入力に戻る</button>
                </div>
                <div class="flex-1 lg:flex-none ml-2">
                    <button type="button" class="submit-button" @click="$emit('submit')" :disabled="isProcessing">
                        申し込みをする
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import SectionLabel from "../kyuseiki/SectionLabel";
import FormLabel from "../kyuseiki/FormLabel";
import FormConfirm from "../kyuseiki/FormConfirm";
import ApplyDetailTable from "./ApplyDetailTable";
import ConfirmHeader from "./ConfirmHeader";
import FormHeader from "../kyuseiki/FormHeader";
import ShowStep from "../kyuseiki/ShowStep";

export default {
    name: "StartConfirm",
    components: {ShowStep, FormHeader, ConfirmHeader, ApplyDetailTable, FormConfirm, FormLabel, SectionLabel},
    props: {
        request: {
            type: Object,
        },
        payment: {
            type: Object,
        },
        isProcessing: {
            type: Boolean
        },
        price: {
            type: Object
        }
    },

    computed: {
        payTimes() {
            if (this.request.pay_times === 'bonus') {
                return 'ボーナス払';
            } else {
                return `${this.request.pay_times}回払`;
            }
        }
    }
}
</script>

<style scoped>

</style>
